import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getModuleOutput, rerunModule } from '../services/api';

export function useModuleData(moduleId) {
  return useQuery({
    queryKey: ['module', moduleId],
    queryFn: () => getModuleOutput(moduleId),
    enabled: !!moduleId,
  });
}

export function useRerunModule(moduleId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => rerunModule(moduleId),
    onSuccess: () => {
      // Refetch after a short delay (let n8n finish)
      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: ['module', moduleId] });
      }, 3000);
    },
  });
}
